export var ContentShape;
(function (ContentShape) {
    ContentShape["StaticImage"] = "static_image";
    ContentShape["ShortVerticalVideo"] = "short_vertical_video";
    ContentShape["Story"] = "story";
    ContentShape["Carousel"] = "carousel";
    ContentShape["LongFormVideo"] = "long_form_video";
})(ContentShape || (ContentShape = {}));
export const SHAPE_PLATFORMS = {
    [ContentShape.StaticImage]: {
        live: ['instagram', 'facebook', 'linkedin', 'pinterest'],
        comingSoon: ['x', 'threads'],
    },
    [ContentShape.ShortVerticalVideo]: {
        live: ['instagram', 'facebook', 'tiktok', 'linkedin', 'youtube_shorts', 'pinterest'],
        comingSoon: [],
    },
    [ContentShape.Story]: {
        live: [],
        comingSoon: ['instagram_story', 'facebook_story', 'snapchat'],
    },
    [ContentShape.Carousel]: {
        live: ['instagram', 'facebook'],
        comingSoon: ['linkedin_carousel'],
    },
    [ContentShape.LongFormVideo]: {
        live: [],
        comingSoon: ['youtube', 'linkedin_video'],
    },
};
export const DEFAULT_PRIMARY_PLATFORM = {
    [ContentShape.StaticImage]: 'instagram',
    [ContentShape.ShortVerticalVideo]: 'instagram',
    [ContentShape.Story]: null,
    [ContentShape.Carousel]: 'instagram',
    [ContentShape.LongFormVideo]: null,
};
export const TOPIC_LIVE_SHAPES = [
    ContentShape.StaticImage,
    ContentShape.ShortVerticalVideo,
    ContentShape.Carousel,
];
export const NARRATIVE_LIVE_SHAPES = TOPIC_LIVE_SHAPES;
export const DEFAULT_SHAPE_ORDER = [
    ContentShape.StaticImage,
    ContentShape.ShortVerticalVideo,
    ContentShape.Carousel,
];
export function getShapeForLivePlatform(platform) {
    for (const [shape, manifest] of Object.entries(SHAPE_PLATFORMS)) {
        if (manifest.live.includes(platform))
            return shape;
    }
    return null;
}
export function getDefaultPrimaryPlatform(shape) {
    return DEFAULT_PRIMARY_PLATFORM[shape];
}
export function getCandidatePlatforms(shape) {
    return SHAPE_PLATFORMS[shape].live;
}
export function getComingSoonPlatforms(shape) {
    return SHAPE_PLATFORMS[shape].comingSoon;
}
export function isPostProjectData(data) {
    return typeof data === 'object' && data !== null && data.kind === 'post';
}
export function isAnyWrapperProjectData(data) {
    return isPostProjectData(data);
}
//# sourceMappingURL=content-shape.js.map